import { Mbb_SHOPPING_CART_EVENTS } from "../Components/shopping-cart-constants";
import type { MbbBundle, MbbBundleEvent } from "../shop-types";

export const parseMbbBundle = (json: string): MbbBundle => JSON.parse(json) as MbbBundle;

export const dispatchMbbAddProduct = (bundle: MbbBundle, openButton: HTMLElement, analyticsListName: string) => {
  const mbbBundle: MbbBundle = { ...bundle, analyticsListName };

  document.dispatchEvent(
    new CustomEvent<MbbBundleEvent>(Mbb_SHOPPING_CART_EVENTS.ADD_PRODUCT, { detail: { mbbBundle, openButton } }),
  );
};
